"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _UserSettingsRecordAllOfReflectionScoreRange = _interopRequireDefault(require("./UserSettingsRecordAllOfReflectionScoreRange"));
var _UserSettingsRecordAllOfSeverityRange = _interopRequireDefault(require("./UserSettingsRecordAllOfSeverityRange"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The UserSettingsRecord model module.
 * @module model/UserSettingsRecord
 * @version 4.0.0
 */
var UserSettingsRecord = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>UserSettingsRecord</code>.
   * Used to store a user&#39;s default overlay settings (used in the PDF reports or in the Calendar view) and default filter settings (used in the PDF reports or on all Results views)
   * @alias module:model/UserSettingsRecord
   */
  function UserSettingsRecord() {
    _classCallCheck(this, UserSettingsRecord);
    UserSettingsRecord.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(UserSettingsRecord, null, [{
    key: "initialize",
    value: function initialize(obj) {
      obj['record_type'] = 'user_settings_record';
      obj['filter_mode'] = 'any';
      obj['record_types'] = '= PainRecord,DailyReflection';
    }

    /**
     * Constructs a <code>UserSettingsRecord</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserSettingsRecord} obj Optional instance to populate.
     * @return {module:model/UserSettingsRecord} The populated <code>UserSettingsRecord</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new UserSettingsRecord();
        if (data.hasOwnProperty('record_type')) {
          obj['record_type'] = _ApiClient["default"].convertToType(data['record_type'], 'String');
        }
        if (data.hasOwnProperty('pref_type')) {
          obj['pref_type'] = _ApiClient["default"].convertToType(data['pref_type'], 'String');
        }
        if (data.hasOwnProperty('filter_mode')) {
          obj['filter_mode'] = _ApiClient["default"].convertToType(data['filter_mode'], 'String');
        }
        if (data.hasOwnProperty('pain_type')) {
          obj['pain_type'] = _ApiClient["default"].convertToType(data['pain_type'], ['String']);
        }
        if (data.hasOwnProperty('severity')) {
          obj['severity'] = _ApiClient["default"].convertToType(data['severity'], 'String');
        }
        if (data.hasOwnProperty('severity_range')) {
          obj['severity_range'] = _UserSettingsRecordAllOfSeverityRange["default"].constructFromObject(data['severity_range']);
        }
        if (data.hasOwnProperty('record_types')) {
          obj['record_types'] = _ApiClient["default"].convertToType(data['record_types'], 'String');
        }
        if (data.hasOwnProperty('reflection_score')) {
          obj['reflection_score'] = _ApiClient["default"].convertToType(data['reflection_score'], 'String');
        }
        if (data.hasOwnProperty('reflection_score_range')) {
          obj['reflection_score_range'] = _UserSettingsRecordAllOfReflectionScoreRange["default"].constructFromObject(data['reflection_score_range']);
        }
        if (data.hasOwnProperty('timing_h_m_s')) {
          obj['timing_h_m_s'] = _ApiClient["default"].convertToType(data['timing_h_m_s'], 'String');
        }
        if (data.hasOwnProperty('pain_duration')) {
          obj['pain_duration'] = _ApiClient["default"].convertToType(data['pain_duration'], 'String');
        }
        if (data.hasOwnProperty('pain_duration_unit')) {
          obj['pain_duration_unit'] = _ApiClient["default"].convertToType(data['pain_duration_unit'], 'String');
        }
        if (data.hasOwnProperty('timing')) {
          obj['timing'] = _ApiClient["default"].convertToType(data['timing'], Object);
        }
        if (data.hasOwnProperty('time_offset')) {
          obj['time_offset'] = _ApiClient["default"].convertToType(data['time_offset'], 'Number');
        }
        if (data.hasOwnProperty('location')) {
          obj['location'] = _ApiClient["default"].convertToType(data['location'], ['String']);
        }
        if (data.hasOwnProperty('symptom')) {
          obj['symptom'] = _ApiClient["default"].convertToType(data['symptom'], ['String']);
        }
        if (data.hasOwnProperty('character')) {
          obj['character'] = _ApiClient["default"].convertToType(data['character'], ['String']);
        }
        if (data.hasOwnProperty('alleviating_factor')) {
          obj['alleviating_factor'] = _ApiClient["default"].convertToType(data['alleviating_factor'], ['String']);
        }
        if (data.hasOwnProperty('ineffective_factor')) {
          obj['ineffective_factor'] = _ApiClient["default"].convertToType(data['ineffective_factor'], ['String']);
        }
        if (data.hasOwnProperty('aggravating_factor')) {
          obj['aggravating_factor'] = _ApiClient["default"].convertToType(data['aggravating_factor'], ['String']);
        }
        if (data.hasOwnProperty('environment')) {
          obj['environment'] = _ApiClient["default"].convertToType(data['environment'], ['String']);
        }
        if (data.hasOwnProperty('meaningful_activities')) {
          obj['meaningful_activities'] = _ApiClient["default"].convertToType(data['meaningful_activities'], ['String']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserSettingsRecord</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserSettingsRecord</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['record_type'] && !(typeof data['record_type'] === 'string' || data['record_type'] instanceof String)) {
        throw new Error("Expected the field `record_type` to be a primitive type in the JSON string but got " + data['record_type']);
      }
      // ensure the json data is a string
      if (data['pref_type'] && !(typeof data['pref_type'] === 'string' || data['pref_type'] instanceof String)) {
        throw new Error("Expected the field `pref_type` to be a primitive type in the JSON string but got " + data['pref_type']);
      }
      // ensure the json data is a string
      if (data['filter_mode'] && !(typeof data['filter_mode'] === 'string' || data['filter_mode'] instanceof String)) {
        throw new Error("Expected the field `filter_mode` to be a primitive type in the JSON string but got " + data['filter_mode']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['pain_type'])) {
        throw new Error("Expected the field `pain_type` to be an array in the JSON data but got " + data['pain_type']);
      }
      // ensure the json data is a string
      if (data['severity'] && !(typeof data['severity'] === 'string' || data['severity'] instanceof String)) {
        throw new Error("Expected the field `severity` to be a primitive type in the JSON string but got " + data['severity']);
      }
      // validate the optional field `severity_range`
      if (data['severity_range']) {
        // data not null
        _UserSettingsRecordAllOfSeverityRange["default"].validateJSON(data['severity_range']);
      }
      // ensure the json data is a string
      if (data['record_types'] && !(typeof data['record_types'] === 'string' || data['record_types'] instanceof String)) {
        throw new Error("Expected the field `record_types` to be a primitive type in the JSON string but got " + data['record_types']);
      }
      // ensure the json data is a string
      if (data['reflection_score'] && !(typeof data['reflection_score'] === 'string' || data['reflection_score'] instanceof String)) {
        throw new Error("Expected the field `reflection_score` to be a primitive type in the JSON string but got " + data['reflection_score']);
      }
      // validate the optional field `reflection_score_range`
      if (data['reflection_score_range']) {
        // data not null
        _UserSettingsRecordAllOfReflectionScoreRange["default"].validateJSON(data['reflection_score_range']);
      }
      // ensure the json data is a string
      if (data['timing_h_m_s'] && !(typeof data['timing_h_m_s'] === 'string' || data['timing_h_m_s'] instanceof String)) {
        throw new Error("Expected the field `timing_h_m_s` to be a primitive type in the JSON string but got " + data['timing_h_m_s']);
      }
      // ensure the json data is a string
      if (data['pain_duration'] && !(typeof data['pain_duration'] === 'string' || data['pain_duration'] instanceof String)) {
        throw new Error("Expected the field `pain_duration` to be a primitive type in the JSON string but got " + data['pain_duration']);
      }
      // ensure the json data is a string
      if (data['pain_duration_unit'] && !(typeof data['pain_duration_unit'] === 'string' || data['pain_duration_unit'] instanceof String)) {
        throw new Error("Expected the field `pain_duration_unit` to be a primitive type in the JSON string but got " + data['pain_duration_unit']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['location'])) {
        throw new Error("Expected the field `location` to be an array in the JSON data but got " + data['location']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['symptom'])) {
        throw new Error("Expected the field `symptom` to be an array in the JSON data but got " + data['symptom']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['character'])) {
        throw new Error("Expected the field `character` to be an array in the JSON data but got " + data['character']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['alleviating_factor'])) {
        throw new Error("Expected the field `alleviating_factor` to be an array in the JSON data but got " + data['alleviating_factor']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['ineffective_factor'])) {
        throw new Error("Expected the field `ineffective_factor` to be an array in the JSON data but got " + data['ineffective_factor']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['aggravating_factor'])) {
        throw new Error("Expected the field `aggravating_factor` to be an array in the JSON data but got " + data['aggravating_factor']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['environment'])) {
        throw new Error("Expected the field `environment` to be an array in the JSON data but got " + data['environment']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['meaningful_activities'])) {
        throw new Error("Expected the field `meaningful_activities` to be an array in the JSON data but got " + data['meaningful_activities']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} record_type
 * @default 'user_settings_record'
 */
UserSettingsRecord.prototype['record_type'] = 'user_settings_record';

/**
 * Record Settings could represent overlay or filter only
 * @member {module:model/UserSettingsRecord.PrefTypeEnum} pref_type
 */
UserSettingsRecord.prototype['pref_type'] = undefined;

/**
 * Defines the logic in which to apply the specified criteria. This parameter only applies to pref_type filter_settings.
 * @member {module:model/UserSettingsRecord.FilterModeEnum} filter_mode
 * @default 'any'
 */
UserSettingsRecord.prototype['filter_mode'] = 'any';

/**
 * Should be in the form of an array of strings that represents the pain types to include.  This criteria only applies to record_type PainRecord and pref_type filter_settings.
 * @member {Array.<module:model/UserSettingsRecord.PainTypeEnum>} pain_type
 */
UserSettingsRecord.prototype['pain_type'] = undefined;

/**
 * Should be in the form of an operator followed by a space and then an integer from 0 to 10 (e.g. '> 0', '< 5', '= 10').  Valid operators include Greater Than - '>', Less Than - '<', or Equal To - '='.  This criteria only applies to record_type PainRecord and pref_type filter_settings.
 * @member {String} severity
 */
UserSettingsRecord.prototype['severity'] = undefined;

/**
 * @member {module:model/UserSettingsRecordAllOfSeverityRange} severity_range
 */
UserSettingsRecord.prototype['severity_range'] = undefined;

/**
 * Should be in the form of the equal operator followed by a space and then PainRecord, DailyReflection, or both. This criteria only applies to pref_type filter_settings. Also, criteria should ALWAYS be applied regardless of the filter mode.
 * @member {module:model/UserSettingsRecord.RecordTypesEnum} record_types
 * @default '= PainRecord,DailyReflection'
 */
UserSettingsRecord.prototype['record_types'] = '= PainRecord,DailyReflection';

/**
 * Should be in the form of an operator followed by a space and then an integer from 0 to 10 (e.g. '> 0', '< 5', '=1 0').  Valid operators include Greater Than - '>', Less Than - '<', or Equal To - '='.   This criteria only applies to record_type DailyReflection and pref_type filter_settings.
 * @member {String} reflection_score
 */
UserSettingsRecord.prototype['reflection_score'] = undefined;

/**
 * @member {module:model/UserSettingsRecordAllOfReflectionScoreRange} reflection_score_range
 */
UserSettingsRecord.prototype['reflection_score_range'] = undefined;

/**
 * Should be in the form of an operator followed by a space and then an integer that represents the time of day in milliseconds since midnight (e.g. '> 0', '< 43200000', '= 86399000').  Valid operators include Greater Than - '>', Less Than - '<', or Equal To - '='.  The maximum integer value that is allowed is 1s less than 24hrs (86399000).   This criteria only applies to record_type PainRecord and pref_type filter_settings.
 * @member {String} timing_h_m_s
 */
UserSettingsRecord.prototype['timing_h_m_s'] = undefined;

/**
 * Should be in the form of an operator followed by a space and then an integer that represents the pain duration in seconds (e.g. '> 0', '< 86400', '= 500').  Valid operators include Greater Than - '>', Less Than - '<', or Equal To - '='.   This criteria only applies to record_type PainRecord and pref_type filter_settings.
 * @member {String} pain_duration
 */
UserSettingsRecord.prototype['pain_duration'] = undefined;

/**
 * Represents user's preferred duration unit.  This value is only used by the front-end to display the correct unit in the \"Timing\" section (e.g. Greater than Dec. 15, 2017). This criteria only applies to record_type PainRecord and pref_type filter_settings.
 * @member {module:model/UserSettingsRecord.PainDurationUnitEnum} pain_duration_unit
 */
UserSettingsRecord.prototype['pain_duration_unit'] = undefined;

/**
 * Should be in the form of an operator followed by a space and then an integer that represents the record time in milliseconds since Jan 1, 1970 (UNIX time) (e.g. '> 0', '< 1464535713000', '= 1496071715000').  Valid operators include Greater Than - '>', Less Than - '<', Greater Than or Equal To - '>=', Less Than or Equal To - '<=', and Equal To - '='.  Another valid criteria represents an \"in between\" value using two operators and start and end values in a JSON array (e.g ['> 1464535713000', '< 1496071715000'] ). If `change_values` set to 1 - then only 'in between' criteria is valid. This criteria applies to all record types but only pref_type filter_settings. Also, criteria should ALWAYS be applied regardless of the filter mode.
 * @member {Object} timing
 */
UserSettingsRecord.prototype['timing'] = undefined;

/**
 * Number of milliseconds between the creating user's local device and UTC at the time the filter was created. It satisfies the following formula `UTC + time_offset = timing`. This value is only used by the front-end to display the correct calendar dates in the \"Timing\" section (e.g. Greater than Dec. 15, 2017), given the user's local timezone.  This parameter only applies to pref_type `filter_settings`.
 * @member {Number} time_offset
 */
UserSettingsRecord.prototype['time_offset'] = undefined;

/**
 * @member {Array.<String>} location
 */
UserSettingsRecord.prototype['location'] = undefined;

/**
 * @member {Array.<String>} symptom
 */
UserSettingsRecord.prototype['symptom'] = undefined;

/**
 * @member {Array.<String>} character
 */
UserSettingsRecord.prototype['character'] = undefined;

/**
 * @member {Array.<String>} alleviating_factor
 */
UserSettingsRecord.prototype['alleviating_factor'] = undefined;

/**
 * @member {Array.<String>} ineffective_factor
 */
UserSettingsRecord.prototype['ineffective_factor'] = undefined;

/**
 * @member {Array.<String>} aggravating_factor
 */
UserSettingsRecord.prototype['aggravating_factor'] = undefined;

/**
 * @member {Array.<String>} environment
 */
UserSettingsRecord.prototype['environment'] = undefined;

/**
 * @member {Array.<String>} meaningful_activities
 */
UserSettingsRecord.prototype['meaningful_activities'] = undefined;

/**
 * Allowed values for the <code>pref_type</code> property.
 * @enum {String}
 * @readonly
 */
UserSettingsRecord['PrefTypeEnum'] = {
  /**
   * value: "overlay_settings"
   * @const
   */
  "overlay_settings": "overlay_settings",
  /**
   * value: "filter_settings"
   * @const
   */
  "filter_settings": "filter_settings"
};

/**
 * Allowed values for the <code>filter_mode</code> property.
 * @enum {String}
 * @readonly
 */
UserSettingsRecord['FilterModeEnum'] = {
  /**
   * value: "all"
   * @const
   */
  "all": "all",
  /**
   * value: "any"
   * @const
   */
  "any": "any",
  /**
   * value: "none"
   * @const
   */
  "none": "none"
};

/**
 * Allowed values for the <code>pain_type</code> property.
 * @enum {String}
 * @readonly
 */
UserSettingsRecord['PainTypeEnum'] = {
  /**
   * value: "Intermittent"
   * @const
   */
  "Intermittent": "Intermittent",
  /**
   * value: "Constant"
   * @const
   */
  "Constant": "Constant",
  /**
   * value: "Breakthrough"
   * @const
   */
  "Breakthrough": "Breakthrough"
};

/**
 * Allowed values for the <code>record_types</code> property.
 * @enum {String}
 * @readonly
 */
UserSettingsRecord['RecordTypesEnum'] = {
  /**
   * value: "= PainRecord,DailyReflection"
   * @const
   */
  "PainRecord,DailyReflection": "= PainRecord,DailyReflection",
  /**
   * value: "= PainRecord"
   * @const
   */
  "PainRecord": "= PainRecord",
  /**
   * value: "= DailyReflection"
   * @const
   */
  "DailyReflection": "= DailyReflection"
};

/**
 * Allowed values for the <code>pain_duration_unit</code> property.
 * @enum {String}
 * @readonly
 */
UserSettingsRecord['PainDurationUnitEnum'] = {
  /**
   * value: "Hours"
   * @const
   */
  "Hours": "Hours",
  /**
   * value: "Minutes"
   * @const
   */
  "Minutes": "Minutes",
  /**
   * value: "Seconds"
   * @const
   */
  "Seconds": "Seconds"
};
var _default = exports["default"] = UserSettingsRecord;